import { render } from "./node.vue?vue&type=template&id=5557d41e&scoped=true&ts=true"
import script from "./node.vue?vue&type=script&lang=ts"
export * from "./node.vue?vue&type=script&lang=ts"

import "./node.vue?vue&type=style&index=0&id=5557d41e&lang=scss&scoped=true"

import exportComponent from "../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5557d41e"]])

export default __exports__